import React, { useEffect, useState } from "react";

import {
  FaWhatsapp,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

import {
  HiOutlineMenuAlt3,
  HiOutlineX,
} from "react-icons/hi";


function Header() {

  /* =======================================================
     CONFIGURACIÓN
  ======================================================= */

  const menuItems = [
    {
      id: "quien-soy",
      label: "¿Quién soy?",
    },
    {
      id: "demos",
      label: "Demos",
    },
    {
      id: "contacto",
      label: "Contacto",
    },
  ];


  const socialLinks = [
    {
      name: "Instagram",
      url: "https://instagram.com/",
      icon: <FaInstagram />,
    },
    {
      name: "Facebook",
      url: "https://facebook.com/",
      icon: <FaFacebookF />,
    },
    {
      name: "LinkedIn",
      url: "https://linkedin.com/",
      icon: <FaLinkedinIn />,
    },
  ];


  /* =======================================================
     STATE
  ======================================================= */

  const [menuOpen, setMenuOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  const [activeSection, setActiveSection] = useState("");


  /* =======================================================
     HEADER AL HACER SCROLL
  ======================================================= */

  useEffect(() => {

    const handleScroll = () => {

      setScrolled(window.scrollY > 20);

    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, []);


  /* =======================================================
     BLOQUEAR BODY CUANDO MENU MOBILE ESTÁ ABIERTO
  ======================================================= */

  useEffect(() => {

    if (menuOpen) {

      document.body.classList.add("menu-open");

    } else {

      document.body.classList.remove("menu-open");

    }

    return () => {
      document.body.classList.remove("menu-open");
    };

  }, [menuOpen]);


  /* =======================================================
     CERRAR MENU CON ESC
  ======================================================= */

  useEffect(() => {

    const handleEscape = (event) => {

      if (event.key === "Escape") {
        setMenuOpen(false);
      }

    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };

  }, []);


  /* =======================================================
     DETECTAR SECCIÓN ACTIVA
  ======================================================= */

  useEffect(() => {

    const sections = menuItems
      .map((item) => document.getElementById(item.id))
      .filter(Boolean);


    if (!sections.length) return;


    const observer = new IntersectionObserver(
      (entries) => {

        const visibleSection = entries.find(
          (entry) => entry.isIntersecting
        );

        if (visibleSection) {

          setActiveSection(visibleSection.target.id);

        }

      },
      {
        root: null,
        rootMargin: "-30% 0px -55% 0px",
        threshold: 0,
      }
    );


    sections.forEach((section) => {
      observer.observe(section);
    });


    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };

  }, []);


  /* =======================================================
     SMOOTH SCROLL
  ======================================================= */

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);

  if (!section) return;

  /* INICIO SIEMPRE HASTA ARRIBA */
  if (sectionId === "inicio") {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setActiveSection(sectionId);
    setMenuOpen(false);

    return;
  }

  /* RESTO DE SECCIONES */
  const header = document.querySelector(".main-header");

  const headerHeight = header
    ? header.offsetHeight
    : 80;

  const elementPosition =
    section.getBoundingClientRect().top +
    window.pageYOffset;

  const offsetPosition =
    elementPosition -
    headerHeight -
    10;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });

  setActiveSection(sectionId);
  setMenuOpen(false);
};


  /* =======================================================
     LOGO → TOP
  ======================================================= */

  const scrollToTop = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setMenuOpen(false);

  };


  return (

    <>

      {/* ===================================================
          HEADER
      =================================================== */}

      <header
        className={`main-header ${
          scrolled ? "main-header--scrolled" : ""
        }`}
      >

        <div className="main-header__container">


          {/* =========================
              LOGO
          ========================= */}

          
            <a
              className="main-header__brand"
              onClick={() => scrollToSection("inicio")}
              aria-label="Ir al inicio"
            >
              <img
                src="/assets/img/1000346783.svg"
                alt="MP Locución Comercial e Institucional"
                className="main-header__logo"
              />

              <span className="main-header__slogan">
                Una voz que conecta
              </span>
            </a>



          {/* =========================
              MENÚ DESKTOP
          ========================= */}

          <nav
            className="main-header__nav"
            aria-label="Navegación principal"
          >

            <ul className="main-header__nav-list">

              {menuItems.map((item) => (

                <li
                  key={item.id}
                  className="main-header__nav-item"
                >

                  <button
                    type="button"
                    className={`main-header__nav-link ${
                      activeSection === item.id
                        ? "active"
                        : ""
                    }`}
                    onClick={() =>
                      scrollToSection(item.id)
                    }
                  >

                    {item.label}

                  </button>

                </li>

              ))}

            </ul>

          </nav>


          {/* =========================
              ACCIONES DESKTOP
          ========================= */}

          <div className="main-header__actions">

            <a
              href="https://wa.me/525530098562"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-section__button contact-section__button--primary"
            >

              <FaWhatsapp />

              <span>
                WhatsApp
              </span>

            </a>


            {/* MENU HAMBURGUESA */}

            <button
              type="button"
              className="main-header__menu-button"
              onClick={() => setMenuOpen(true)}
              aria-label="Abrir menú"
              aria-expanded={menuOpen}
              aria-controls="mobile-navigation"
            >

              <HiOutlineMenuAlt3 />

            </button>

          </div>


        </div>

      </header>


      {/* ===================================================
          OVERLAY
      =================================================== */}

      <div
        className={`mobile-menu-overlay ${
          menuOpen
            ? "mobile-menu-overlay--visible"
            : ""
        }`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />


      {/* ===================================================
          MOBILE DRAWER
      =================================================== */}

      <aside
        id="mobile-navigation"
        className={`mobile-menu ${
          menuOpen
            ? "mobile-menu--open"
            : ""
        }`}
        aria-hidden={!menuOpen}
      >


        {/* =========================
            HEADER DRAWER
        ========================= */}

        <div className="mobile-menu__header">

          <button
            type="button"
            className="mobile-menu__brand"
            onClick={scrollToTop}
          >

            <img
              src="/assets/img/logo.png"
              alt="MP"
              className="mobile-menu__logo"
            />

          </button>


          <button
            type="button"
            className="mobile-menu__close"
            onClick={() => setMenuOpen(false)}
            aria-label="Cerrar menú"
          >

            <HiOutlineX />

          </button>

        </div>


        {/* =========================
            INTRO
        ========================= */}

        <div className="mobile-menu__intro">

          <h3>
            Locución comercial
            <br />
            e institucional
          </h3>

          <p>
            Voz que conecta, comunica
            y genera experiencias.
          </p>

        </div>


        {/* =========================
            NAVEGACIÓN
        ========================= */}

        <nav
          className="mobile-menu__nav"
          aria-label="Navegación móvil"
        >

          {menuItems.map((item, index) => (

            <button
              key={item.id}
              type="button"
              className={`mobile-menu__link ${
                activeSection === item.id
                  ? "active"
                  : ""
              }`}
              onClick={() =>
                scrollToSection(item.id)
              }
            >

              <span className="mobile-menu__number">

                {String(index + 1).padStart(2, "0")}

              </span>


              <span className="mobile-menu__label">

                {item.label}

              </span>

            </button>

          ))}

        </nav>


        {/* =========================
            CONTACTO
        ========================= */}

        <div className="mobile-menu__contact">

          <span className="mobile-menu__section-title">
            Contacto
          </span>


          <a
            href="mailto:monicapalaciosgmz@gmail.com"
            className="mobile-menu__contact-link"
          >

            <span className="mobile-menu__contact-icon">

              <FaEnvelope />

            </span>

            <div>

              <small>
                Escríbenos
              </small>

              <strong>
                monicapalaciosgmz@gmail.com
              </strong>

            </div>

          </a>


          <a
            href="tel:+520000000000"
            className="mobile-menu__contact-link"
          >

            <span className="mobile-menu__contact-icon">

              <FaPhoneAlt />

            </span>

            <div>

              <small>
                Teléfono
              </small>

              <strong>
                +52 55 3009 8562
              </strong>

            </div>

          </a>


          <a
            href="https://wa.me/5215530098562"
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-menu__contact-link"
          >

            <span className="mobile-menu__contact-icon">

              <FaWhatsapp />

            </span>

            <div>

              <small>
                WhatsApp
              </small>

              <strong>
                Enviar mensaje
              </strong>

            </div>

          </a>

        </div>


        {/* =========================
            SOCIAL
        ========================= */}

        {/* <div className="mobile-menu__social-wrapper">

          <span className="mobile-menu__section-title">
            Sígueme
          </span>

          <div className="mobile-menu__social">

            {socialLinks.map((social) => (

              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mobile-menu__social-link"
                aria-label={social.name}
                title={social.name}
              >

                {social.icon}

              </a>

            ))}

          </div>

        </div> */}


        {/* =========================
            FOOTER
        ========================= */}

        <div className="mobile-menu__footer">

          <small>
            © {new Date().getFullYear()}
          </small>

        </div>


      </aside>

    </>

  );

}

export default Header;